export const NumberToDollar = (stringValue: number) => {
    const numberValue = Number(stringValue)
    if (stringValue === null || stringValue === undefined || Number.isNaN(stringValue)) return `n/a`
    return '$ ' + StringToLargeNumber(numberValue.toFixed(2)
      .replace('.', '.'))
  }

  export const StringToLargeNumber = (stringValue: string | number) =>
    stringValue.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')